<template>
  <div class="pt-4 pb-24 px-4">
    <h3 class="text-3xl font-bold mb-5">{{ $t('settings') }}</h3>
    <template v-if="loading">
      <div class="rounded-lg" :class="[$theme.cardBg]">
        <LoadingBlock />
      </div>
    </template>
    <template v-else>
      <DisconnectExchangeAlert :exchanges="exchanges" />

      <div class="mb-3 rounded-lg" :class="[$theme.cardBg]">
        <div class="border-b" :class="[$theme.cardBorderColor]">
          <router-link to="/setting/profile" class="flex items-center justify-between px-2 py-2">
            <div class="flex items-center">
              <div class="w-7 h-7 text-white flex items-center justify-center rounded-lg" :class="[$theme.bgBtnIcons]">
                <UserIcon class="w-5" />
              </div>
              <span class="ml-2">{{ $t('my_profile') }}</span>
            </div>
            <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
              <ChevronRightIcon class="w-5" />
            </div>
          </router-link>
        </div>
        <div class="border-b" :class="[$theme.cardBorderColor]">
          <router-link to="/setting/language" class="flex items-center justify-between px-2 py-2">
            <div class="flex items-center">
              <div class="w-7 h-7 bg-purple-600 text-white flex items-center justify-center rounded-lg">
                <LanguageIcon class="w-5" />
              </div>
              <span class="ml-2">{{ $t('language') }}</span>
            </div>
            <div class="flex items-center" :class="[$theme.cardLabelTextColor]">
              {{ selectedLanguageTitle }}
              <ChevronRightIcon class="w-5" />
            </div>
          </router-link>
        </div>
        <div class="border-b" :class="[$theme.cardBorderColor]">
          <router-link to="/setting/security" class="flex items-center justify-between px-2 py-2">
            <div class="flex items-center">
              <div class="w-7 h-7 bg-gray-600 text-white flex items-center justify-center rounded-lg">
                <LockClosedIcon class="w-5" />
              </div>
              <span class="ml-2">{{ $t('security') }}</span>
            </div>
            <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
              <ChevronRightIcon class="w-5" />
            </div>
          </router-link>
        </div>
        <div class="border-b" :class="[$theme.cardBorderColor]">
          <router-link to="/setting/payment-cards" class="flex items-center justify-between px-2 py-2">
            <div class="flex items-center">
              <div class="w-7 h-7 bg-blue-500 text-white flex items-center justify-center rounded-lg">
                <CreditCardIcon class="w-5" />
              </div>
              <span class="ml-2">{{ $t('payment_cards') }}</span>
            </div>
            <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
              <ChevronRightIcon class="w-5" />
            </div>
          </router-link>
        </div>
        <div>
          <a href="#" @click="onChangeTheme" class="flex items-center justify-between px-2 py-2">
            <div class="flex items-center">
              <div class="w-7 h-7 flex items-center justify-center rounded-lg border" :class="[$theme.cardBorderColor]">
                <BeakerIcon class="w-5" :class="[$theme.textBtnSvgIcons]" />
              </div>
              <span class="ml-2">{{ $t('design') }}</span>
            </div>
            <div class="flex items-center" :class="[$theme.cardLabelTextColor]">
              {{ $user.theme === 'light' ? $t('light') : $t('dark') }}
              <ChevronRightIcon class="w-5" />
            </div>
          </a>
        </div>
      </div>

      <div class="rounded-lg" :class="[$theme.cardBg]">
        <div v-for="exchange in exchanges" :key="exchange.id" class="border-b" :class="[$theme.cardBorderColor]">
          <router-link :to="`/exchange/${exchange.id}`" class="flex items-center justify-between px-3 py-2">
            <div class="flex items-center relative">
              <div :class="[
                'w-2 h-2 rounded-full absolute left-5 top-0',
                exchange.status ? 'bg-green-custom' : $theme.bgDangerColor
              ]"></div>
              <img :src="`/img/${exchange.exchange_slug}.png`" class="w-6 mr-2 rounded-full" /> {{ exchange.title }}
              <span class="ml-2" :class="[$theme.cardLabelTextColor]">ID: {{ exchange.id }}</span>
            </div>
            <div>
              <template v-if="!exchange.status_connected">
                <ExclamationTriangleIcon class="w-5 h-5" :class="[$theme.textRed]" />
              </template>
            </div>
          </router-link>
        </div>
        <router-link to="/create-exchange" class="flex items-center px-3 py-2 text-orange">
          <div class="flex items-center">
            <PlusIcon class="w-5 mr-1" /> {{ $t('add_exchange_account') }}
          </div>
        </router-link>
      </div>

      <!-- <div class="rounded-lg mt-3" :class="[$theme.cardBg]">
        <div class="border-b" :class="[$theme.cardBorderColor]">
          <div v-if="forexAccounts.length === 0" class="flex items-center justify-between px-3 py-2">
            Нет аккаунтов
          </div>
          <div v-else>
            <div v-for="forexAccount in forexAccounts" :key="forexAccount.id" class="border-b" :class="[$theme.cardBorderColor]">
              <router-link :to="`/forex/accounts/${forexAccount.id}`" class="flex items-center justify-between px-3 py-2">
                <div class="flex items-center relative">
                  <img :src="`/img/${forexAccount.app_type}.png`" class="w-6 mr-2 rounded-full" />
                  {{ appTypeTitle[forexAccount.app_type] }}
                  <span class="ml-2" :class="[$theme.cardLabelTextColor]">{{ forexAccount.title }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <router-link to="/forex/create-account" class="flex items-center px-3 py-2 text-orange">
          <div class="flex items-center">
            <PlusIcon class="w-6 mr-2" /> {{ $t('add_exchange_account') }}
          </div>
        </router-link>
      </div> -->

      <div class="mt-3">
        <div class="rounded-lg" :class="[$theme.cardBg]">
          <div class="border-b" :class="[$theme.cardBorderColor]">
            <router-link to="/setting/signals" class="flex items-center justify-between px-2 py-2">
              <div class="flex items-center">
                <div class="w-7 h-7 bg-green-500 text-white flex items-center justify-center rounded-lg">
                  <SignalIcon class="w-5" />
                </div>
                <span class="ml-2">{{ $t('signals') }}</span>
              </div>
              <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
                <ChevronRightIcon class="w-5" />
              </div>
            </router-link>
          </div>
          <div class="border-b" :class="[$theme.cardBorderColor]">
            <router-link to="/setting/signal-logs" class="flex items-center justify-between px-2 py-2">
              <div class="flex items-center">
                <div class="w-7 h-7 bg-blue-500 text-white flex items-center justify-center rounded-lg">
                  <SignalIcon class="w-5" />
                </div>
                <span class="ml-2">{{ $t('signal_logs') }}</span>
              </div>
              <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
                <ChevronRightIcon class="w-5" />
              </div>
            </router-link>
          </div>
          <div class="border-b" :class="[$theme.cardBorderColor]">
            <router-link to="/setting/notifications" class="flex items-center justify-between px-2 py-2">
              <div class="flex items-center">
                <div class="w-7 h-7 bg-red-500 text-white flex items-center justify-center rounded-lg" :class="[$theme.bgBtnIcons]">
                  <BellIcon class="w-5" />
                </div>
                <span class="ml-2">{{ $t('notifications') }}</span>
              </div>
              <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
                <ChevronRightIcon class="w-5" />
              </div>
            </router-link>
          </div>
          <div>
            <router-link to="/setting/logs" class="flex items-center justify-between px-2 py-2">
              <div class="flex items-center">
                <div class="w-7 h-7 bg-gray-950 text-white flex items-center justify-center rounded-lg">
                  <LogsIcon />
                </div>
                <span class="ml-2">{{ $t('logs') }}</span>
              </div>
              <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
                <ChevronRightIcon class="w-5" />
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="mt-3 rounded-lg" :class="[$theme.cardBg]">
        <div>
          <router-link to="/terms" class="flex items-center justify-between px-2 py-2">
            <div class="flex items-center">
              <div class="w-7 h-7 text-black p-0.5 flex items-center justify-center rounded-lg border" :class="[$theme.cardBorderColor]">
                <DocumentTextIcon class="w-5" :class="[$theme.textBtnSvgIcons]" />
              </div>
              <span class="ml-2">{{ $t('terms') }}</span>
            </div>
            <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
              <ChevronRightIcon class="w-5" />
            </div>
          </router-link>
        </div>
      </div>

      <template v-if="$settings.support_links">
        <div class="mt-3 rounded-lg" :class="[$theme.cardBg]">
          <div v-for="(supportLink, supportLinkIdx) in $settings.support_links" :key="supportLinkIdx" :class="[
            (supportLinkIdx) !== ($settings.support_links.length - 1) ? 'border-b ' + $theme.cardBorderColor : ''
          ]">
            <a :href="supportLink.url" class="flex items-center justify-between px-2 py-2">
              <div class="flex items-center">
                <div class="w-7 h-7 text-black flex items-center justify-center rounded-lg border overflow-hidden relative" :class="[$theme.cardBorderColor]">
                  <SupportIcon class="w-9 h-9 absolute -top-1 -left-1 pr-0.5 pb-0.5" :class="[$theme.textBtnSvgIcons]" />
                </div>
                <span class="ml-2">{{ supportLink.title[$user.language_code] }}</span>
              </div>
              <div class="flex items-center text-sm" :class="[$theme.cardLabelTextColor]">
                <ChevronRightIcon class="w-5" />
              </div>
            </a>
          </div>
        </div>
      </template>

      <div v-if="user && parseInt(user.id) === 1" class="mt-6">
        <router-link to="/logs" class="block px-6 py-3 bg-gray-200 text-red-500 rounded-lg text-center">System logs</router-link>
      </div>
    </template>
  </div>

  <TransitionRoot as="template" :show="isOpenChangeTheme">
    <Dialog class="relative z-50" @close="isOpenChangeTheme = false">
      <div class="fixed inset-0 bg-gray-950 bg-opacity-45 transition-opacity" />
      <div class="fixed inset-0 z-50 flex items-end justify-center">
        <TransitionChild
            as="template"
            enter="transform transition ease-in-out duration-300"
            enter-from="translate-y-full opacity-0"
            enter-to="translate-y-0 opacity-100"
            leave="transform transition ease-in-out duration-300"
            leave-from="translate-y-0 opacity-100"
            leave-to="translate-y-full opacity-0"
        >
          <DialogPanel
              class="w-full rounded-t-2xl px-4 pt-5 pb-4 text-left shadow-orange sm:p-6"
              :class="[$theme.secondBaseBg]"
          >
            <DialogTitle as="h3" class="leading-6" :class="[$theme.baseTextColor]">
              {{ $t("select_theme") }}
            </DialogTitle>
            <div class="grid grid-cols-2 gap-4 mt-4">
              <a href="#" @click="updateTheme('light')" class="flex items-center justify-between py-3 px-4 rounded-lg cursor-pointer relative" :class="[$theme.cardBg]">
                <span :class="[$user.theme !== 'light' ? 'border-2' : 'border-2', $user.theme === 'light' ? $theme.radioActiveBorderColor : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']" aria-hidden="true" />
                <div class="flex items-center relative">
                  <div class="w-8 h-8 flex items-center justify-center rounded-full" :class="[$theme.outlineBtnBg]">
                    <PhotoIcon class="w-5" :class="[$theme.navActiveTextColor2]" />
                  </div>
                  <span class="ml-2" :class="[$theme.baseTextColor]">{{ $t('light') }}</span>
                </div>
                <CheckCircleIcon :class="[$user.theme === 'light' ? $theme.textOrange : 'invisible', 'size-6']" aria-hidden="true" />
              </a>
              <a href="#" @click="updateTheme('dark')" class="flex items-center justify-between py-3 px-4 rounded-lg cursor-pointer relative" :class="[$theme.cardBg]">
                <span :class="[$user.theme !== 'dark' ? 'border-2' : 'border-2', $user.theme === 'dark' ? $theme.radioActiveBorderColor : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']" aria-hidden="true" />
                <div class="flex items-center relative">
                  <div class="w-8 h-8 flex items-center justify-center rounded-full" :class="[$theme.outlineBtnBg]">
                    <PhotoIcon class="w-5" :class="[$theme.navActiveTextColor2]" />
                  </div>
                  <span class="ml-2" :class="[$theme.baseTextColor]">{{ $t('dark') }}</span>
                </div>
                <CheckCircleIcon :class="[$user.theme === 'dark' ? $theme.textOrange : 'invisible', 'size-6']" aria-hidden="true" />
              </a>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import LoadingBlock from '@/components/LoadingBlock.vue';
import LogsIcon from '@/components/icons/LogsIcon.vue';
import SupportIcon from '@/components/icons/SupportIcon.vue';

import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

import {
  PlusIcon,
  LanguageIcon,
  BellIcon,
  ChevronRightIcon,
  SignalIcon,
  UserIcon,
  LockClosedIcon,
  DocumentTextIcon,
  CreditCardIcon,
  BeakerIcon,
  PhotoIcon,
} from '@heroicons/vue/24/outline'
import {CheckCircleIcon} from "@heroicons/vue/20/solid";
import {ExclamationTriangleIcon} from "@heroicons/vue/24/solid";
import {addBackButton, hideBackButton} from "@/helpers/telegramHelper";
import DisconnectExchangeAlert from "@/components/elem/DisconnectExchangeAlert.vue";

export default {
  components: {
    DisconnectExchangeAlert,
    PlusIcon,
    LanguageIcon,
    LoadingBlock,
    BellIcon,
    ChevronRightIcon,
    SignalIcon,
    UserIcon,
    LockClosedIcon,
    ExclamationTriangleIcon,
    DocumentTextIcon,
    CreditCardIcon,
    LogsIcon,
    SupportIcon,
    BeakerIcon,
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckCircleIcon,
    PhotoIcon,
  },

  computed: {
    selectedLanguageTitle() {
      for (const lang of this.languages) {
        if (this.$user.language_code === lang.language_code) {
          return lang.native_title;
        }
      }

      return '';
    }
  },

  methods: {
    loadLanguages() {
      this.$api.get('/languages').then((result) => {
        console.log(result.data.data)
        this.languages = result.data.data;
      }).catch(e => {
        alert(e.message)
        this.error = e
      })
    },

    loadExchanges() {
      this.$api.get('/exchanges').then((result) => {
        this.exchanges = result.data.data
        this.loading = false
      }).catch(e => {
        alert(e.message)
        this.error = e
      })
    },

    loadForexAccounts() {
      this.$api.get('/forex/accounts').then((result) => {
        console.log(result.data)
        this.forexAccounts = result.data;
      }).catch(e => {
        alert(e.message)
        this.error = e
      })
    },

    onChangeTheme() {
      console.log('Change theme', this.$user);

      this.isOpenChangeTheme = true
    },

    updateTheme(theme) {
      this.$api.post('/user/update-theme', {
        theme: theme,
      }).then((result) => {
        console.log(result.data)
        window.location.reload()
      }).catch(e => {
        alert(e.message)
        this.error = e
      })
    },
  },

  data() {
    return {
      loading: true,
      user: null,
      exchanges: [],
      forexAccounts: [],
      languages: [],
      error: null,
      appTypeTitle: {
        mt4: 'MetaTrader4',
        mt5: 'MetaTrader5',
      },
      isOpenChangeTheme: false,
    }
  },

  mounted() {
    console.log('Setting View.');

    this.loadExchanges();
    //this.loadForexAccounts();
    this.loadLanguages();
    addBackButton(this.$router);
  },

  beforeUnmount() {
    hideBackButton();
  }
}
</script>
